import { getStoredSessionToken } from "./appleAuth";
import type { SectionLabels } from "./sectionLabels";

export type LanguageDto = {
  recordName: string;
  code: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
  defaultSource: string | null;
  labels: SectionLabels;
  labelsJSON: string;
};

export type LanguagesResponse = {
  languages: LanguageDto[];
  warnings: string[];
  configured: boolean;
  environment: string;
};

async function authHeader(): Promise<HeadersInit> {
  const token = getStoredSessionToken();
  if (!token) throw new Error("Sign in required.");
  return { Authorization: `Bearer ${token}` };
}

async function readJson<T>(res: Response): Promise<T> {
  const data = (await res.json()) as T & { error?: string };
  if (!res.ok) throw new Error(data.error ?? `Request failed (${res.status})`);
  return data;
}

export async function fetchLanguages(): Promise<LanguagesResponse> {
  const headers = new Headers(await authHeader());
  const res = await fetch("/api/languages", { headers });
  return readJson(res);
}

export async function saveLanguageLabels(
  code: string,
  labels: SectionLabels,
): Promise<LanguageDto> {
  const headers = new Headers(await authHeader());
  headers.set("Content-Type", "application/json");
  const res = await fetch(`/api/languages/${encodeURIComponent(code)}/labels`, {
    method: "POST",
    headers,
    body: JSON.stringify({ labels }),
  });
  const data = await readJson<{ language: LanguageDto }>(res);
  return data.language;
}
